
import { Component, Vue } from "vue-property-decorator";
import { mdiArrowLeftCircle } from "@mdi/js";
import CompanyInfo from "@/components/company/CompanyInfo.vue";
import CompanySubscription from "@/components/company/CompanySubscription.vue";
import router from "@/router";

@Component({
    components: {
        CompanyInfo,
        CompanySubscription,
    },
})
export default class Company extends Vue {
    private arrowBack: any = mdiArrowLeftCircle;
    private currentTab: string = "info";
    private company: any = {
        name: "",
        subscription: null,
        type: "",
        activitySector: "",
        siret: "",
        siren: "",
        users: [],
        masterId: undefined,
    };

    private mounted() {
        if (this.$route.params.id) {
            this.getCompany();
        }
    }

    private getCompany() {
        return this.$store.dispatch("admin/companies/readById", {
            id: this.$route.params.id,
            options: {
                master: true,
            },
        }).then((data) => {
            this.company = data;
            this.company.users = [data.master];
            this.company.masterId = data.master.id;
        });
    }

    private async changeTab(tab) {
        if (this.currentTab !== tab) {
            await this.getCompany();
            this.currentTab = tab;
        }
    }

    private edit(company: any) {
        this.$store.dispatch("admin/companies/updateById", {id: company.id, company}).then((res) => {
            router.push({name: "companies"});
        }).catch((err) => {
            this.$store.commit("alerts/displayError", {
                msg: this.$t(`register.error.${err.response.data.type}`),
            });
        });
    }
}
